// @flow
// Flow type for withLatestFrom is incomplete. Hence this helper for convenience.
import { Observable } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

export default <+A, +B>(other: Observable<B>): ((Observable<A>) => Observable<B>) =>
  // $FlowFixMe withLatestFrom
  withLatestFrom(other, (a, b) => b);
